function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.74911 1.41146H11.3358C11.7024 1.41146 12.0024 1.71146 12.0024 2.07812C12.0024 2.44479 11.7024 2.74479 11.3358 2.74479H0.669108C0.302441 2.74479 0.00244141 2.44479 0.00244141 2.07812C0.00244141 1.71146 0.302441 1.41146 0.669108 1.41146H4.25577L4.74244 0.444792C4.85577 0.218125 5.08244 0.078125 5.33577 0.078125H6.66911C6.92244 0.078125 7.14911 0.218125 7.26911 0.444792L7.74911 1.41146ZM1.33575 4.07812H10.6691C10.8557 4.07812 11.0357 4.15812 11.1624 4.29146C11.2891 4.42479 11.3491 4.61146 11.3357 4.79812L11.0024 8.74479L10.7757 11.4715C10.7291 12.0181 10.4691 12.4981 10.0957 12.8448C9.72241 13.1915 9.22241 13.4115 8.66908 13.4115H3.33575C2.78241 13.4115 2.28241 13.1915 1.90908 12.8448C1.53575 12.4981 1.27575 12.0181 1.22908 11.4715L1.00241 8.74479L0.669082 4.79812C0.655748 4.61812 0.722415 4.43146 0.842415 4.29146C0.969082 4.15812 1.14908 4.07812 1.33575 4.07812Z",
  fill: "white"
});

function SvgImageViewerDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageViewerDelete);
export default __webpack_public_path__ + "static/media/image-viewer-delete.5916b2da.svg";
export { ForwardRef as ReactComponent };